export default __webpack_public_path__ + "static/media/festival-logo.ee02fd89.png";